import { render, staticRenderFns } from "./advAuthMethod.vue?vue&type=template&id=b3add39c&scoped=true&"
import script from "./advAuthMethod.vue?vue&type=script&lang=js&"
export * from "./advAuthMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3add39c",
  null
  
)

export default component.exports